import { render, staticRenderFns } from "./about-the-lib.vue?vue&type=template&id=b25499b0"
var script = {}
import style0 from "./about-the-lib.vue?vue&type=style&index=0&id=b25499b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports